import React, {
  useState,
  useContext
} from 'react';

// ? context
import GuideFlowContext from '../../GuideFlowContext';

// ? Self-packed Components || Functions
import { GuideDetail } from '../GuideDetailGeneral';

// ^ plugins
// import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

/**
 * @author Odin, Nick
 * @level layouts/GuideFlow/GuideEntryGeneral
 * @component GuideEntryGeneral
 * @description GuideEntryGeneral Component
*/
export const GuideEntryGeneral = () => {

  // $init data
  const { t } = useTranslation();
  const minStep = 1;
  const maxStep = 4;

  // # states
  const [currentStep, setCurrentStep] = useState(1);

  // = styles
  // % context
  const { classes, isSmallTablet } = useContext(GuideFlowContext);

  // - methods

  // & handled data
  const titleObj = {
    step1: t('shortcutAndStatus'),
    step2: `${t('quickStart')}`,
    step3: `${t('runningJobs')}`,
    step4: t('language')
  }

  const arrowTypeObj = {
    step1: 'top',
    step2: 'left',
    step3: 'right',
    step4: 'top'
  }

  return (
    <div className={`${classes.stepContainer}`}>
      <div
        className={
          `${isSmallTablet
            ? classes.guideAdvice
            : classes[`entryGeneralDetail${currentStep}`]
          }`
        }
      >
        <GuideDetail
          arrowType={arrowTypeObj[`step${currentStep}`]}
          hasPrev={(currentStep > minStep && currentStep <= maxStep)}
          haxNext={(currentStep >= minStep && currentStep < maxStep)}
          setCurrentStep={setCurrentStep}
          title={titleObj[`step${currentStep}`]}
        >
          <div className={`${classes.whiteSpacePreLine}`}>
            {t(`guide.entry.user.step${currentStep}.detail`)}
          </div>
        </GuideDetail>
      </div>
    </div>
  );
};

// GuideEntryGeneral.propTypes = {
//   isShow: PropTypes.bool
// };

export default GuideEntryGeneral;
